import { columns } from "../../../../dtos/columns";
import AccionesCobranza from "../components/accionesCobranza";
import { CoberturaPoliza } from "../models/polizaSeguro";

interface IProps {
    controlTabla: any;
    setCoberturaEditar?: React.Dispatch<React.SetStateAction<CoberturaPoliza | undefined>>;
    setIsEditarCobertura?: (value: boolean) => void;
    onCreateEditClick?: () => void;
    refresh?: () => void;
} 

export function useColumnsCobranza({ controlTabla, setCoberturaEditar, setIsEditarCobertura, onCreateEditClick, refresh }: IProps) {
    const COLUMNS: columns<CoberturaPoliza>[] = [
        {
            name: 'Acciones',
            selector: (row) => '',
            cell: (row) => (
                <AccionesCobranza
                    cobertura={row}
                    setCoberturaEditar={setCoberturaEditar}
                    setIsEditarCobertura={setIsEditarCobertura}
                    onCreateEditClick={onCreateEditClick}
                    refresh={refresh}
                />
            ),
            allowOverflow: true,
            button: true,
            export: false,
            alling: 'center'
        },
        {
            name: 'Código Cobertura',
            selector: (row) => row.codigoCobertura,
            sortable: true,
            sortField: 'codigoCobertura',
            wrap: true,
            export: true
        },
        {
            name: 'Tasa',
            selector: (row) => row.tasa,
            sortable: true,
            sortField: 'tasa',
            wrap: true,
            export: true
        },
        {
            name: 'Prima',
            selector: (row) => row.prima,
            sortable: true,
            sortField: 'prima',
            wrap: true,
            export: true
        },
    ];

    return { COLUMNS };
}